import React from "react";
import { useTranslation } from "react-i18next";

import TitleFragment from "./TitleFragment";
import SEO from "./SEO";

function QtTraining() {
    const { t } = useTranslation();

    return (
        <>
            <SEO
                title={t('qttraining.seoTitle')}
                description={t('qttraining.seoDescription')}
                keywords={t('qttraining.seoKeywords')}
                url="/qt-training"
                schemaType="course"
            />
            <TitleFragment title={t('qttraining.pageTitle')} />
        </>
    )
}

export default QtTraining;